import Private from './Private';

export default Private;
